import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Layout from '@/layout/index.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location: any): any {
  return (originalPush.call(this, location) as any).catch((err: any) => err)
}
Vue.use(VueRouter)

export type IMyRouterConfig = RouteConfig & {
  expanded?: Boolean
  isActive?: Boolean
}

export const routes: Array<IMyRouterConfig> = [
  {
    path: '/',
    component: Layout,
    meta: {title: '首页', hideSideBar: true},
    redirect: '/homePage'
  },
  {
    path: '/home',
    name: 'home',
    component: Layout,
    redirect: '/homePage',
    children: [
      {
        path: '/homePage',
        name: 'homePage',
        component: () => import(/* webpackChunkName: "home" */ '../views/home/homePage.vue'),
        meta: {
          title: '首页'
        }
      }
    ]
  },
  {
    path: '/agency',
    name: 'agency',
    component: Layout,
    redirect: '/agency/subUser',
    children: [
      {
        path: '/agency/subUser',
        name: 'susUser',
        component: () => import('../views/agency/subUser.vue'),
        meta: {
          title: '我的客户'
        }
      },
      {
        path: '/agency/settlement',
        name: 'settlement',
        component: () => import('../views/agency/settlement.vue'),
        meta:{
          title:'明细'
        }
      }
    ]
  },
  {
    path: '/common',
    component: Layout,
    redirect: '/common/task',
    children: [
      // {
      //   path: '/common/index',
      //   name: 'commonStore',
      //   component: () => import(/* webpackChunkName: "common" */ '../views/common/index.vue'),
      //   meta: {
      //     title: '数据云仓'
      //   }
      // },
      {
        path: '/common/create',
        name: 'commonCreate',
        component: () => import(/* webpackChunkName: "common" */ '../views/common/create.vue'),
        meta: {
          title: '极速筛选号码开通'
        }
      },
      {
        path: '/common/task',
        name: 'commonTask',
        component: () => import(/* webpackChunkName: "common" */ '../views/common/task.vue'),
        meta: {
          title: '所有任务'
        }
      }
    ]
  },
  {
    path: '/myFilter',
    component: Layout,
    redirect: '/myFilter/index',
    children: [
      {
        path: '/myFilter/index',
        name: 'myFilter',
        component: () => import(/* webpackChunkName: "myFilter" */ '../views/myFilter/index.vue'),
        meta: {
          title: '代筛任务'
        }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    meta: {title: '用户管理', icon: 'userManager', role: 1},
    redirect: '/account/index',
    children: [
      {
        path: '/account/index',
        name: 'Account',
        component: () => import(/* webpackChunkName: "account" */ '../views/account/index.vue'),
        meta: {
          title: '账号管理',
          role: 1
        }
      },
      {
        path: '/account/balance',
        name: 'Balance',
        component: () => import(/* webpackChunkName: "account" */ '../views/account/balance.vue'),
        meta: {
          title: '用户余额',
          role: 1
        }
      },
      {
        path: '/account/charge',
        name: 'Charge',
        component: () => import(/* webpackChunkName: "account" */ '../views/account/charge.vue'),
        meta: {
          title: '用户充值',
          role: 1
        }
      },
      {
        path: '/account/detail',
        name: 'Detail',
        component: () => import(/* webpackChunkName: "account" */ '../views/account/detail.vue'),
        meta: {
          title: '消费明细',
          role: 1
        }
      },
      {
        path: '/account/autoCharge',
        name: 'AutoCharge',
        component: () => import(/* webpackChunkName: "account" */ '../views/account/autoCharge.vue'),
        meta: {
          title: '自动充值订单',
          role: 1,
        }
      },
      {
        path: '/account/chargeRule',
        name: 'ChargeRule',
        component: () => import(/* webpackChunkName: "account" */ '../views/account/chargeRule.vue'),
        meta: {
          title: '自动充值规则',
          role: 1,
        }
      },
      {
        path: '/account/menuAuth',
        name: 'MenuAuth',
        component: () => import(/* webpackChunkName: "account" */ '../views/account/menuAuth.vue'),
        meta: {
          title: '菜单权限',
          role: 1
        }
      },
      {
        path: '/account/logs',
        name: 'logs',
        component: () => import(/* webpackChunkName: "account" */ '../views/account/logs.vue'),
        meta: {
          title: '操作日志',
          role: 1
        }
      }
    ]
  },
  {
    path: 'content',
    component: Layout,
    meta: {title: '内容管理', icon: 'content'},
    redirect: '/content/notice',
    children: [
      {
        path: '/content/notice',
        name: 'Notice',
        component: () => import(/* webpackChunkName: "content" */ '../views/content/notice.vue'),
        meta: {
          title: '公告管理'
        }
      },
      {
        path: '/content/comment',
        name: 'Comment',
        component: () => import(/* webpackChunkName: "content" */ '../views/content/comment.vue'),
        meta: {
          title: '留言管理'
        }
      },
      {
        path: '/content/adv',
        name: 'Adv',
        component: () => import(/* webpackChunkName: "content" */ '../views/content/adv.vue'),
        meta: {
          title: '广告位管理'
        }
      },
      {
        path: '/content/carousal',
        name: 'Carousal',
        component: () => import(/* webpackChunkName: "content" */ '../views/content/carousal.vue'),
        meta: {
          title: '轮播图管理'
        }
      },
      {
        path: '/content/price',
        name: 'Price',
        component: () => import(/* webpackChunkName: "content" */ '../views/content/price.vue'),
        meta: {
          title: '价格管理'
        }
      }
    ]
  },
  {
    path: '/filterManager',
    component: Layout,
    meta: {title: '筛选管理', icon: 'filterManager', role: 1},
    redirect: '/filterManager/index',
    children: [
      {
        path: '/filterManager/index',
        name: 'filterManager',
        component: () =>
          import(/* webpackChunkName: "filterManager" */ '../views/filterManager/index.vue'),
        meta: {
          title: '筛选管理',
          role: 1
        }
      }
    ]
  },
  {
    path: '/bill',
    component: Layout,
    meta: {title: '账单管理', icon: 'userManager'},
    redirect: '/bill/index',
    children: [
      {
        path: '/bill/index',
        name: 'CustomBill',
        component: () => import(/* webpackChunkName: "bill" */ '../views/bill/index.vue'),
        meta: {
          title: '消费明细'
        }
      },
      {
        path: '/bill/remain',
        name: 'CustomRemain',
        component: () => import(/* webpackChunkName: "bill" */ '../views/bill/remain.vue'),
        meta: {
          title: '账户余额'
        }
      },
      {
        path: '/bill/charge',
        name: 'CustomCharge',
        component: () => import(/* webpackChunkName: "bill" */ '../views/bill/charge.vue'),
        meta: {
          title: '充值记录'
        }
      },
      {
        path: '/bill/product',
        name: 'CustomProduct',
        component: () => import(/* webpackChunkName: "bill" */ '../views/bill/product.vue'),
        meta: {
          title: '产品一览'
        }
      }
    ]
  },
  {
    path: '/tools',
    component: Layout,
    meta: {title: '实用工具', icon: 'tools'},
    redirect: '/tools/section',
    children: [
      {
        path: '/tools/section',
        name: 'Section',
        component: () => import(/* webpackChunkName: "tools" */ '../views/tools/section.vue'),
        meta: {
          title: '精选号段'
        }
      },
      {
        path: '/tools/haoma',
        name: 'Haoma',
        component: () => import(/* webpackChunkName: "tools" */ '../views/tools/haoma.vue'),
        meta: {
          title: '号码生成'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "sign" */ '../views/sign/login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/regist',
    name: 'Regist',
    component: () => import(/* webpackChunkName: "sign" */ '../views/sign/regist.vue'),
    meta: {
      title: '注册'
    }
  },
  {
    path: '/check',
    name: 'Check',
    component: () => import(/* webpackChunkName: "sign" */ '../views/sign/check.vue'),
    meta: {
      title: '客服查验'
    }
  },
  {
    path: '/forget',
    name: 'Forget',
    component: () => import(/* webpackChunkName: "sign" */ '../views/sign/forget.vue'),
    meta: {
      title: '忘记密码'
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes
})

export default router
